import MuiDrawer from "@mui/material/Drawer";
import { CSSObject, styled, Theme } from "@mui/material/styles";
import { LayoutElementSizes } from "../../../../../../common/ui";

const openedMixins = (theme: Theme): CSSObject => ({
	width: LayoutElementSizes.SideMenuWidth,
	transition: theme.transitions.create("width", {
		easing: theme.transitions.easing.easeOut,
		duration: theme.transitions.duration.enteringScreen,
	}),
	overflowX: "hidden",
});

const closedMixins = (theme: Theme): CSSObject => ({
	transition: theme.transitions.create("width", {
		easing: theme.transitions.easing.easeOut,
		duration: theme.transitions.duration.leavingScreen,
	}),
	overflowX: "hidden",
	width: `calc(${theme.spacing(7)}) + 1px`,
	[theme.breakpoints.up("xs")]: {
		width: `calc(${theme.spacing(8)} + 1px)`,
	},
});

/**
 * MenuWrapper is the component used to render GreenRouter UI side menu.
 */
const MenuWrapper = styled(MuiDrawer, {
	shouldForwardProp: (props) => props !== "open",
})(({ theme, open }) => ({
	width: LayoutElementSizes.SideMenuWidth,
	flexShrink: 0,
	whiteSpace: "nowrap",
	boxSizing: "border-box",
	...(open && {
		...openedMixins(theme),
		"& .MuiDrawer-paper": openedMixins(theme),
	}),
	...(!open && {
		...closedMixins(theme),
		"& .MuiDrawer-paper": closedMixins(theme),
	}),
}));

export default MenuWrapper;
